export const TWO_LINE_TAGS_MAX_DEPTH = 30;
export const THREE_LINE_TAGS_MAX_DEPTH = 48;
